<template>
  <div class="full-height q-mb-md">
    <div class="row container-crud">
      <div class="fit">
        <q-card class="no-shadow">
          <div class="title-card">
            <span class="text-h6">{{ $gettext("CONTRACT_DATA") }}</span>
          </div>
          <q-card-section class="q-px-lg">
            <span v-if="elements.length == 1">
              <q-btn color="grey-3" text-color="primary" icon="description" class="view-button-carrier" flat
                :label="$gettext('CONTRACT_HISTORY')" @click="openModel" :disabled="!this.elements[0].dadosForm">
                <q-tooltip>{{ $gettext("CONTRACT_HISTORY_HINT") }}</q-tooltip>
              </q-btn>
            </span>
          </q-card-section>

          <q-dialog v-if="flModal" v-model="flModal" maximized>
            <q-layout view="Lhh lpR fff" container class="bg-white modal-medium">
              <q-header class="bg-primary">
                <q-toolbar>
                  <q-toolbar-title>{{
                    $gettext("CONTRACT_DATA")
                    }}</q-toolbar-title>
                  <q-btn v-close-popup flat round dense icon="cancel" />
                </q-toolbar>
              </q-header>
              <q-page-container class="card-container-modal">
                <modal-contract-additive :fields="pageDialog.datatable" :extra-params="pageDialog.extraParam"
                  nm-interface="contract.additive" noneselect :is-paginated="true" />
              </q-page-container>
            </q-layout>
          </q-dialog>
          <page-detail v-if="formsDetail" name="detail" :forms="formsDetail" />
          <div class="title-card">
            <span class="text-h6">{{ $gettext("CONTRACT_SERVICE") }}</span>
          </div>
          <div v-for="(composition, index) in compositions" :key="index" :name="'xtab-' + index" keep-alive>
            <div v-for="(data, i) in composition.data" :key="i" :name="'xtab-' + i" keep-alive>
              <div v-if="getContractServices(data) && data.formsService">
                <div class="header-service row">
                  <div v-for="(obj, index) in data.formsService[0].inputs"
                       :key="index"
                       :class="getFieldClass(obj, index, data.formsService[0].inputs)">
                    <label>{{ obj.label }}:</label>
                    {{
                      obj.label != $gettext('PRIORITY') && obj.label != $gettext('PROVISION_OF_SERVICE') ?
                        formatedValue(
                          data.formsService[0].dadosForm[obj.name],
                          obj
                        ) :
                        data.formsService[0].dadosForm[obj.name] == '1' ? $gettext('YES') : $gettext('NO')
                    }}
                  </div>
                </div>
                <div class="tw-mx-4">
                  <change-product-form :replaceProduct="data.replaceProduct" :contractServiceId="data.id"
                    :serviceTypeId="data.serviceType" :serviceTypeDescription="data.serviceType_nmDescricao" />
                </div>
                <div v-if="isValueRange(data.serviceType)">
                  <ContractItemBillingDataTable :contractServiceId="data.id" :datatable="data.formsService.datatable"
                    @actionButton="actionButtonItem"></ContractItemBillingDataTable>
                </div>
                <div v-else>
                  <q-card-section class="q-pb-lg card-table">
                    <contract-item-data-table v-if="data.formsService" :ref="'dataTableItem-' + data.id" class="q-mt-sm"
                      :buttons="data.formsService.datatable.buttons" :buttons-filter="filterButtons"
                      :fields="data.formsService.datatable.columns" :extra-params="{ contractServiceId: data.id }"
                      :default-http-options="defaultHttpOptions"
                      nm-interface="contractItem.pesquisarByContractServiceId" noneselect row-buttons
                      :isPaginated="false" @action-button="actionButtonItem" />
                  </q-card-section>
                </div>
              </div>
            </div>
          </div>
        </q-card>
      </div>
    </div>
    <modal v-if="dadosModal.show" :show="dadosModal.show" :maximized="true" v-bind="dadosModal"
      :detail="dadosModal.detail" @input="(show) => (dadosModal.show = show)" @action-button="actionButtonUpdate"
      hideClearButton />
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import {
  JtCrud,
  JtDataTable,
  JtechDataTableUtils,
  JtDynamicForm
} from 'jtech-webcomps'
import ContractItemDataTable from './ContractItemDataTable'
import ModalContractAdditive from './ModalContractAdditive'
import ChangeProductForm from './ChangeProductForm.vue'
import { repository } from 'jtech'
import ContractItemBillingDataTable from './ContractItemBillingDataTable.vue'
import { serviceTypeStatus } from 'src/shared/inf-tabela-descricao/ServiceType.enum'
const { pageDetail, modal, page, pageSearch } = JtCrud

@Component({
  mixins: [JtDataTable, JtCrud.pageDetail],
  name: 'ContractDetail',
  components: {
    JtDataTable,
    pageDetail,
    modal,
    ContractItemDataTable,
    ModalContractAdditive,
    page,
    pageSearch,
    JtDynamicForm,
    ChangeProductForm,
    ContractItemBillingDataTable
  },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    dadosForm: Object
  }
})
class ContractDetail extends Vue {
  dadosModal = { show: false };
  dataCompositions = [];
  columns = [];
  flModal = false;
  pageDialog = null;
  datatable = null;
  productsOptions = null

  async mounted () {
    this.productsOptions = await this.getProductsOptions()
  }

  isValueRange (serviceType) {
    const serviceTypeEnum = serviceTypeStatus()
    return [serviceTypeEnum.RCC.key, serviceTypeEnum.FREIGHT.key, serviceTypeEnum.FREIGHT_APPORTIONMENT.key].includes(serviceType)
  }

  getProductsOptions = async () => {
    const { registros } = await repository.resolveDatatableModel(
      'contract.hql',
      {
        grid: 'findAllProducts'
      }
    )
    return registros
  }

  async openModel () {
    const params = {
      id: this.elements[0].dadosForm.id,
      contractNumberCrm: this.elements[0].dadosForm.contractNumberCrm,
      additiveNumber: this.elements[0].dadosForm.additiveNumber
    }
    const forms = await repository.resolve('contract.additive', params)

    this.pageDialog = {
      name: 'label',
      params: params,
      forms: forms,
      datatable: forms[0].inputs[3].columns,
      extraParam: params
    }
    this.flModal = true
  }

  async getContractServices (data) {
    if (data.formsService) {
      return data.formsService
    }

    const forms = await repository.resolve('contractService.detalhar', {
      id: data.id
    })
    data.formsService = forms
    data.formsService.datatable = await repository.resolveDatatable(
      'contractItem.pesquisarByContractServiceId',
      { contractServiceId: data.id }
    )
    this.$forceUpdate()
    return forms
  }

  async actionButtonUpdate (button, params) {
    let data
    switch (button.name) {
      case 'btAlterar':
        data = await repository.update(button.action, {
          ...params
        })
        break
      case 'btGravar':
        data = await repository.create(button.action, { ...params })
        break
    }
    const dataTableItem = this.$refs['dataTableItem-' + params.contractService][0]
    dataTableItem.refresh()
    this.dadosModal.show = false
  }

  async actionButtonItem (button, params) {
    if (button.name == 'btAlterar') {
      const data = await repository.resolve('contractItem.alterar', {
        id: params.id
      })
      const isValorizationSale = data[0].dadosForm.serviceType === 20040003
      if (isValorizationSale) {
        const invertedWeighingInput = data[0].inputs.find(input => input.name === 'invertedWeighing')
        if (invertedWeighingInput) {
          invertedWeighingInput.readonly = true
        }
      }

      this.dadosModal = {
        show: true,
        label: this.$gettext('ITEMS_WASTE'),
        forms: data,
        detail: false,
        parent: this,
        params: params
      }
    } else if (button.name == 'btDetalhar') {
      const data = await repository.resolve('contractItem.detalhar', {
        id: params.id
      })
      this.dadosModal = {
        show: true,
        label: this.$gettext('ITEMS_WASTE'),
        forms: data,
        detail: true,
        parent: this,
        params: params
      }
    } else if (button.name == 'btMtr') {
      const paramsAux = {
        ...params,
        contractItemId: params.id,
        id: params.mtrContractItem
      }
      const data = await repository.resolve(
        params.mtrContractItem
          ? 'mtrContractItem.alterar'
          : 'mtrContractItem.gravar',
        paramsAux
      )
      this.dadosModal = {
        show: true,
        label: this.$gettext('MTR_CONTRACT_ITEM'),
        forms: data,
        detail: false,
        parent: this,
        params: paramsAux
      }
    }
  }

  get formsDetail () {
    const inputs = this.forms[0].inputs.filter((x) => x.type != 'COMPOSICAO')

    return [{ ...this.forms[0], inputs }]
  }

  get compositions () {
    return (
      // eslint-disable-next-line no-undef
      _.chain(this.formateInputsArray)
        .find((ci) => ci.type === 'composition')
        .get('elements')
        .filter((e) => {
          if (e.renderIf) {
            return this.__getDynamicConditional(e)
          }
          return true
        })
        .map((e) => {
          if (!this.forms[0].dadosForm[e.model]) {
            this.forms[0].dadosForm[e.model] = []
          }
          e.data = this.forms[0].dadosForm[e.model]
          e.modelForm = this.forms[0].dadosForm
          e.uuid = 'id'
          e.columns.map((col) => {
            col.name = col.name || col.model
            col.field = col.name
            col.sortable = true
            col.align = 'left'
            return col
          })
          return e
        })
        .value() ?? []
    )
  }

  filterButtons (button, dados) {
    return JtechDataTableUtils.filterButtons(button, dados)
  }

  getFieldClass (obj, index, inputs) {
    let colClass = ''
    if (obj.columnsSize) {
      colClass = 'col-' + obj.columnsSize
    } else if (!obj.columnsPerLine) {
      colClass = 'col-12'
    } else {
      colClass = 'col-md-' + 12 / obj.columnsPerLine
    }

    let rowNum = 0
    let colSum = 0

    for (let i = 0; i <= index; i++) {
      const size = inputs[i].columnsSize || 12

      if (colSum + size > 12 && colSum > 0) {
        rowNum++
        colSum = size
      } else {
        colSum += size
      }
    }

    const bgClass = rowNum % 2 === 0 ? 'row-gray' : 'row-white'

    return `${colClass} ${bgClass}`
  }
}

export default ContractDetail
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.title-card {
  padding: 10px 0px 0px;
  margin: 0px 15px;
  border-bottom: 0.3px solid $faded !important;
}

.header-service {
  margin: 0px 15px;
  line-height: 2rem;
  letter-spacing: 0.0125em;
  color: white;
  background-color: #757575;
}

.header-service {
  height: calc(100% - 65px);
  overflow: hidden;
}

.header-service > div {
  padding: 0px 12px;
}

.header-service > div > label {
  font-weight: bold;
}

.row-gray {
  color: white;
  background-color: #757575;
}

.row-white {
  color: #757575;
  background-color: #FFFFFF;
}

.view-button-carrier {
  position: absolute;
  top: -46px;
  right: 14px;
  border-radius: 5px;
}

.striped-area {
  span:nth-child(even) {
    color: white;
    background-color: black;
  }
}
</style>
